import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsSonarcloudComponent } from './simple-icons-sonarcloud.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsSonarcloudComponent ],
    exports:      [ SimpleIconsSonarcloudComponent ],
    bootstrap:    []
})
export class SimpleIconsSonarcloudModule {}
